module.exports = __webpack_public_path__ + "static/media/image-10.a55f33a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/image-10.jpg
// module id = 278
// module chunks = 0